import { render, staticRenderFns } from "./TabColVerovio.vue?vue&type=template&id=4d7637dc&"
import script from "./TabColVerovio.vue?vue&type=script&lang=js&"
export * from "./TabColVerovio.vue?vue&type=script&lang=js&"
import style0 from "./TabColVerovio.vue?vue&type=style&index=0&id=4d7637dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports